import { render, staticRenderFns } from "./ScenarioGame.vue?vue&type=template&id=3295e578"
import script from "./ScenarioGame.vue?vue&type=script&lang=js"
export * from "./ScenarioGame.vue?vue&type=script&lang=js"
import style0 from "./ScenarioGame.vue?vue&type=style&index=0&id=3295e578&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports